import React, { Fragment } from "react";
import { Route } from "react-router-dom";

import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";
import AppFooter from "../../Layout/AppFooter";
import ProfessorComponent from "./Profesor";
import AlumnosComponent from "./Alumnos";
import EscuelasComponent from "./Escuelas";
import CordonComponent from "./Cordon";
import MiniJuegosComponent from "./Mini";
import HistoriasComponent from "./Historias";
import PlanetasComponent from "./Planetas";
import CordonElementosComponent from "./elementosDelJuego/Cordon-admin";
import PlanetasElemetoComponent from "./elementosDelJuego/Planetas-admin";
import HistoriasElementoComponent from "./elementosDelJuego/Historias-admin";
import MiniJuegosElementoComponent from "./elementosDelJuego/MiniJuegos-admin";


const ObjetivosDelJuego = ({ match }) => (
  <Fragment>
    <AppHeader />
    <div className="app-main">
      <AppSidebar />
      <div className="app-main__outer">
        <div className="app-main__inner">
          {/* DOCENTE PREMIUM */}

          <Route
            path={`${match.url}/profesor`}
            component={ProfessorComponent}
          />

          <Route path={`${match.url}/alumno`} component={AlumnosComponent} />

          <Route path={`${match.url}/escuela`} component={EscuelasComponent} />

          <Route path={`${match.url}/cordon`} component={CordonComponent} />

          <Route path={`${match.url}/mini`} component={MiniJuegosComponent} />

          <Route
            path={`${match.url}/Historias`}
            component={HistoriasComponent}
          />

          <Route path={`${match.url}/Planetas`} component={PlanetasComponent} />

          

          {/* ADMIN */}

          <Route path={`${match.url}/elementos/cordones`} component={CordonElementosComponent} />

          <Route path={`${match.url}/elementos/planetas`} component={PlanetasElemetoComponent} />

          <Route path={`${match.url}/elementos/historias`} component={HistoriasElementoComponent} />

          <Route path={`${match.url}/elementos/minijuegos`} component={MiniJuegosElementoComponent} />
          
        </div>
        <AppFooter />
      </div>
    </div>
  </Fragment>
);

export default ObjetivosDelJuego;



// WEBPACK FOOTER //
// src/Pages/ObjetivosDelJuego/index.js